import { render } from "./Mordred.vue?vue&type=template&id=1a46754b&scoped=true&ts=true"
import script from "./Mordred.vue?vue&type=script&lang=ts"
export * from "./Mordred.vue?vue&type=script&lang=ts"

import "./Mordred.vue?vue&type=style&index=0&id=1a46754b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a46754b"]])

export default __exports__